import { render, staticRenderFns } from "./tableChargeCollaborator.vue?vue&type=template&id=00b401d1&scoped=true"
import script from "./tableChargeCollaborator.vue?vue&type=script&lang=js"
export * from "./tableChargeCollaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b401d1",
  null
  
)

export default component.exports